module.exports = __webpack_public_path__ + "img/us.us2b96179.svg";